// Etiketter och värdeuttag för de tre vyer som visar en ifylld beställning:
// StepSummary (steg 3), ChoiceSummary (sidopanelen "Dina val") och PDF.vue.
//
// Layout och filtrering skiljer sig genuint åt mellan vyerna och hör hemma i
// respektive komponent. Det som INTE ska stå på tre ställen är vilka fält som
// finns och vad de heter – annars dyker ett nytt fält upp i sammanfattningen
// men saknas i PDF:en, utan att något går sönder synligt.
//
// Ordningen följer den ordning fälten fylls i (StepCustomer.vue respektive
// newForm() i @/store.js), så att sammanfattningarna läses i samma följd som
// formuläret matas in.
//
// `short` används av sidopanelen, som är för smal för de långa etiketterna.
// `key` låter en vy plocka bort eller specialbehandla ett enskilt fält.

// value() tar emot { customer, common } – dvs. store, eller App:s props.
export const customerFields = [
  { key: 'date', label: 'Datum', value: (s) => s.common.date },
  {
    key: 'place',
    label: 'Arbetsplats/Märkning',
    short: 'Arbetsplats',
    value: (s) => s.common.place,
  },
  { key: 'firstName', label: 'Kund', value: (s) => s.customer.firstName },
  { key: 'number', label: 'Kundnummer', value: (s) => s.customer.number },
  { key: 'phone', label: 'Telefon', value: (s) => s.customer.phone },
  { key: 'lastName', label: 'Referens', value: (s) => s.customer.lastName },
  {
    key: 'deliveryDate',
    label: 'Önskat leveransdatum',
    short: 'Leveransdatum',
    value: (s) => s.customer.deliveryDate,
  },
]

// value() tar emot ett formulär ur store.forms.
export const wellFields = [
  { key: 'littera', label: 'Littera', value: (f) => f.littera },
  { key: 'outflowHeight', label: 'Utgående höjd mm', value: (f) => f.outflowHeight },
  { key: 'finishedHeight', label: 'Höjd färdig mark mm', value: (f) => f.finishedHeight },
  { key: 'dimension', label: 'Dimension mm', value: (f) => f.dimension },
  { key: 'vallning', label: 'Vallning', value: (f) => f.vallning },
  { key: 'betackning', label: 'Betäckning', value: (f) => f.betackning },
]

// value() tar emot en post ur form.items. Rubrikerna versaliseras via CSS,
// inte i texten – både .b-table th och PDF:ens thead sätter text-transform.
export const connectionColumns = [
  { key: 'anslutning', label: 'Anslutningar', value: (i) => i.anslutning },
  { key: 'dimension', label: 'Dimension mm', value: (i) => i.dimension },
  { key: 'rortyp', label: 'Rörtyp/material', value: (i) => i.rortyp },
  { key: 'vinkel', label: 'Vinkel °', value: (i) => i.vinkel },
  { key: 'sandfang', label: 'Sandfång mm', value: (i) => i.sandfang },
  { key: 'stalp', label: 'Stalp mm', value: (i) => i.stalp },
]

// Delar upp en fältlista i rader om två – PDF:ens kunduppgiftstabell har två
// kolumner per rad, och sista raden blir kortare när antalet är udda.
export function inPairs(fields) {
  const rows = []
  for (let i = 0; i < fields.length; i += 2) {
    rows.push(fields.slice(i, i + 2))
  }
  return rows
}
